import { render, staticRenderFns } from "./UiCard.vue?vue&type=template&id=25c54677"
import script from "./UiCard.vue?vue&type=script&lang=ts"
export * from "./UiCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports